import { ecorEnv } from '@/../environments/environment';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Injectable } from '@angular/core';
import { Observable, throwError, of } from 'rxjs';
import { map, take, catchError } from 'rxjs/operators';
import { CalendarDialogComponent } from '../dialogs/calendar-dialog/calendar-dialog.component';

@Injectable()
export class CalendarDialogService {
    constructor(private dialog: MatDialog) { }
    matDialogRef: MatDialogRef<CalendarDialogComponent>;

    open(surveyInstanceId: number) {
        const matDialogConfig = new MatDialogConfig();
        matDialogConfig.panelClass = 'myapp-dialog';
        matDialogConfig.width = '50%';
        matDialogConfig.data = surveyInstanceId;
        matDialogConfig.disableClose = false;
        matDialogConfig.hasBackdrop = false;
        this.matDialogRef = this.dialog.open(CalendarDialogComponent, matDialogConfig);
    }

    confirmed(): Observable<any> {
        if (!this.matDialogRef) {
            return of(null);
        }
        return this.matDialogRef.afterClosed().pipe(
            take(1),
            map(res => {
                return res;
            })
        );
    }
}
